/**
 * A CSV header as a contact field name.
 *
 * Returns null for anything that must not become one:
 *  - a purely numeric header, which would be read back as a template slot
 *  - Meta's own reserved parameter names, which the send path DOES act on —
 *    a column innocently called "header_text" would otherwise change the
 *    message that goes out.
 */
const META_RESERVED = new Set([
  'header_image', 'header_video', 'header_document', 'header_document_filename', 'header_text',
]);
export const contactFieldKey = (header: string | undefined, index: number): string | null => {
  const key = (header || '').trim().toLowerCase()
    .replace(/[^a-z0-9_]+/g, '_').replace(/^_+|_+$/g, '');
  if (!key) return null;
  if (/^[0-9]+$/.test(key)) return null;
  if (META_RESERVED.has(key)) return null;
  if (key === 'name') return null;   // the name has its own picker
  return key;
};
